const styles = theme => ({
  visible: {
    visibility: 'visible',
    background: 'rgba(0, 46, 71, 0.08)',
  },

  hidden: {
    visibility: 'hidden',
  },
  cellWide: {
    width: '40%', // Specific width for the first cell
  },
})

export default styles
